<h2>Your blueprints:</h2>

<p *ngFor="let blueprint of blueprints">
    {{ getName(blueprint.type_id) }}
<!--    {{ blueprint.location_id }} ({{ blueprint.location_flag }})-->
    ({{ blueprint.location_id }})
    ({{ blueprint.location_name }})
</p>
